const list = {
  bloggerId:"博主名称",
  contractId: "关联合同",
  customerName: "客户名称",
  brandName: "品牌名称",
  productName: "产品名称",
  recordPrincipal:"投放负责人",
  mediaType:"资源平台",
  executePrice:"执行价",
  mediaId:"资源" ,
  publishTime:"发布时间" ,
  platfromCompanyId:"平台公司",

}

export default {
  list
}